import React, { useEffect, useState } from 'react';
import { getUserDocket, type UserDocket } from '../../API/docketAPI';

/**
 * Read-only "your USCIS package is ready" card for basic-tier applicants.
 * Self-contained: fetches the docket and renders nothing if none is available
 * (no docket yet, or premium tier — which is filed by LGV and returns 403).
 */
const DocketDownloadCard: React.FC<{ applicationId: number }> = ({ applicationId }) => {
  const [docket, setDocket] = useState<UserDocket | null>(null);

  useEffect(() => {
    let active = true;
    if (!applicationId) return undefined;
    getUserDocket(applicationId)
      .then((d) => {
        if (active) setDocket(d);
      })
      .catch(() => {
        if (active) setDocket(null);
      });
    return () => {
      active = false;
    };
  }, [applicationId]);

  if (!docket?.previewUrl) return null;

  return (
    <div className="border border-[#F4A261] bg-[#FFF8F0] rounded-2xl p-5 md:p-6 mb-6">
      <div className="md:flex items-center justify-between gap-4">
        <div className="md:mb-0 mb-4">
          <h3 className="text-lg font-bold text-[#1B365D] mb-1">
            Your USCIS submission package is ready
          </h3>
          <p className="text-sm text-gray-600">
            Download the complete package, print it, and mail it to USCIS. Keep a copy for your
            records.
          </p>
        </div>
        <a
          href={docket.previewUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block whitespace-nowrap bg-[#F4A261] text-[#1B365D] font-semibold px-6 py-3 rounded-[50px] hover:bg-[#F29449]"
        >
          Download package
        </a>
      </div>
    </div>
  );
};

export default DocketDownloadCard;
